class DZModelDic {
    /**
     * 主键
     */
    id = "";

    /**
     * 字典名称
     */
    name = "";

    /**
     * 图标ID
     */
    icon = "";

    /**
     * 字典类型
     */
    type = "";

    imageUrl = "";
}
export default DZModelDic;
